import DocumentViewerModal from "components/DocumentViewer";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "utils/helpers";

type LegalResearch = {
    research_topic_abstract?: string;
    created_at?: string;
    letter_file?: string;
    letter_file_details?: any;
    research_draft_file?: string;
    research_draft_file_details?: any;
    research_topic?: any;
    documents?: any;
};

interface ResearchTopicCardProps {
    legalResearch: LegalResearch;
}

const ResearchTopicCard: React.FC<ResearchTopicCardProps> = ({
    legalResearch,
}) => {
    const { t } = useTranslation();
    useEffect(() => { console.log("research: ", legalResearch) }, []);
    
    return (
        <div className="bg-gray-100 flex items-center justify-center font-sans">
            <div className="bg-white rounded-xl shadow-lg p-6 w-full">
                {/* Header */}
                <div className="mb-6">
                    <h2 className="text-xl font-semibold text-gray-800">
                        {legalResearch?.research_topic ?
                            `${t("ResearchTopic")}: ${legalResearch?.research_topic}` :
                            t("RequestFiles")}
                    </h2>
                    <p className="text-sm text-gray-500 mt-1">
                        {formatDate(legalResearch?.created_at ?? "")}
                    </p>
                </div>

                {/* Documents Section */}
                <DocumentViewerModal
                    documents={legalResearch.documents}
                    baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_research/legal-research-request-documents/document/`}
                />
            </div>
        </div>
    );
};

export default ResearchTopicCard;